import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { PromoBanner } from "../components/site/PromoBanner";
import { Ribbon } from "../components/site/Ribbon";
import { Services } from "../components/site/Services";
import { MixPackages } from "../components/site/MixPackages";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { Gallery } from "../components/site/Gallery";
import { Testimonials } from "../components/site/Testimonials";
import { Partners } from "../components/site/Partners";
import { AreaSection } from "../components/site/AreaSection";
import { CoverageMap } from "../components/site/CoverageMap";
import { FAQ } from "../components/site/FAQ";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <PromoBanner />
        <Ribbon />
        <Services />
        <MixPackages />
        <WhyChooseUs />
        <Gallery />
        <Testimonials />
        <Partners />
        <AreaSection />
        <CoverageMap />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
